// NOTE: this is a duplicate of what is Asset Pipeline JS folder
import * as $ from 'jquery'

document.addEventListener("DOMContentLoaded", function() {
  // execute this after google analytics tracker has loaded
  // ga(function(tracker) {
  //   $('.gumroad-button').click(function(event) {
  //     tracker.send({
  //       hitType: 'event',
  //       eventCategory: 'Buy Button',
  //       eventAction: 'Click',
  //       eventLabel: 'Gumroad Button'
  //     });
  //   });
  // });


  // google ads signup tracking upon convertkit sign up button click
  $('#ck_subscribe_button').click(function(event) {
    gtag_report_signup_conversion();
  });

})